import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Supplies from "./Supplies/Supplies";

export default function Calculator() {
  const params = useParams();
  const [inputs, setInputs] = useState(null);
  const [name, setName] = useState("Siltek");

  useEffect(() => {
    if (inputs === null) {
      setInputs([]);

      fetch("https://siltek-pss.kovalska.work/api", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          jsonrpc: "2.0",
          id: 1,
          method: "calculator.get.inputs",
          params: {
            id: params.id,
          },
        }),
      }).then(async (response) => {
        const data = await response.json();

        console.log(data);
        setInputs(data.result.inputs);
        setName(data.result.name);
      });
    }
  }, [inputs, params.id]);

  return (
    <>
      <main>
        <Supplies id={params.id} box={inputs} name={name} />
      </main>
    </>
  );
}
